import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import API from "../services/api";
import PageHeader from "../components/PageHeader";
import ClientCard from "../components/ClientCard";
import Card from "../components/Card";
import SearchBar from "../components/SearchBar";
import Button from "../components/Button";
import SkeletonCard from "../components/SkeletonCard";
import Modal from "../components/Modal";
import FormInput from "../components/FormInput";
import Toast from "../components/Toast";

function Clients() {
  const [searchParams] = useSearchParams();
  const [clients, setClients] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState("");
  const [openModal, setOpenModal] = useState(false);
  const [toast, setToast] = useState(null);
  const [nombre, setNombre] = useState("");
  const [telefono, setTelefono] = useState("");
  const [direccion, setDireccion] = useState("");
  const [dni, setDni] = useState("");
  const [cuil, setCuil] = useState("");
  const [email, setEmail] = useState("");
  const [empresa, setEmpresa] = useState("");
  const [ocupacion, setOcupacion] = useState("");
  const [ingresosMensuales, setIngresosMensuales] = useState("");
  const [observaciones, setObservaciones] = useState("");
  const [apellido, setApellido] = useState("");
  const [fechaNacimiento, setFechaNacimiento] = useState("");
  const [sexo, setSexo] = useState("");
  const [nacionalidad, setNacionalidad] = useState("");
  const [estadoCivil, setEstadoCivil] = useState("");

  const [provincia, setProvincia] = useState("");
  const [localidad, setLocalidad] = useState("");
  const [codigoPostal, setCodigoPostal] = useState("");

  const [antiguedadLaboral, setAntiguedadLaboral] = useState("");

  const [referenciaNombre, setReferenciaNombre] = useState("");
  const [referenciaTelefono, setReferenciaTelefono] = useState("");
  const [referenciaRelacion, setReferenciaRelacion] = useState("");

  const [alias, setAlias] = useState("");
  const [cbu, setCbu] = useState("");

  useEffect(() => {
    API.get("/clients")
      .then((res) => setClients(res.data))
      .catch(console.error)
      .finally(() => setLoading(false));
  }, []);

  useEffect(() => {
    if (searchParams.get("action") === "create") setOpenModal(true);
  }, [searchParams]);
  const handleCreateClient = async () => {
    try {
      if (!nombre || !telefono) {
        alert("Completá nombre y teléfono");
        return;
      }

      await API.post("/clients", {
        nombre,
        telefono,
        direccion,
        dni,
        apellido,

        fechaNacimiento,
        sexo,
        nacionalidad,
        estadoCivil,

        provincia,
        localidad,
        codigoPostal,

        antiguedadLaboral,

        referenciaNombre,
        referenciaTelefono,
        referenciaRelacion,

        alias,
        cbu,

        cuil,
        email,

        empresa,
        ocupacion,

        ingresosMensuales: Number(ingresosMensuales) || 0,

        observaciones,

      });

      const res = await API.get("/clients");
      setClients(res.data);

      setNombre("");
      setTelefono("");
      setDireccion("");
      setDni("");
      setCuil("");
      setEmail("");
      setEmpresa("");
      setOcupacion("");
      setIngresosMensuales("");
      setObservaciones("");
      setApellido("");
      setFechaNacimiento("");
      setSexo("");
      setNacionalidad("");
      setEstadoCivil("");

      setProvincia("");
      setLocalidad("");
      setCodigoPostal("");

      setAntiguedadLaboral("");

      setReferenciaNombre("");
      setReferenciaTelefono("");
      setReferenciaRelacion("");

      setAlias("");
      setCbu("");

      setOpenModal(false);
      setToast({
        message: "Cliente creado correctamente",
        type: "success",
      });

      setTimeout(() => {
        setToast(null);
      }, 3000);
    } catch (error) {
      console.error(error);
      setToast({
        message: "Error al crear cliente",
        type: "error",
      });

      setTimeout(() => {
        setToast(null);
      }, 3000);
    }
  };

  const handleDeleteClient = async (client) => {
    const confirmed = window.confirm(
      `¿Estás seguro de que querés eliminar al cliente "${client.nombre}"?`,
    );

    if (!confirmed) {
      return;
    }

    try {
      await API.delete(`/clients/${client._id}`);

      setClients((prevClients) =>
        prevClients.filter((c) => c._id !== client._id),
      );

      setToast({
        message: "Cliente eliminado correctamente",
        type: "success",
      });

      setTimeout(() => {
        setToast(null);
      }, 3000);
    } catch (error) {
      console.error(error);

      const message =
        error.response?.data?.error || "No se pudo eliminar el cliente";

      setToast({
        message,
        type: "error",
      });

      setTimeout(() => {
        setToast(null);
      }, 4000);
    }
  };

  const statusPriority = {
    MOROSO: 1,
    DEUDA: 2,
    ACTIVO: 3,
  };

  const sortedClients = [...clients].sort((a, b) => {
    return (statusPriority[a.estado] || 99) - (statusPriority[b.estado] || 99);
  });
  const filteredClients = sortedClients.filter((client) =>
    client.nombre.toLowerCase().includes(search.toLowerCase()),
  );
  if (loading) {
    return (
      <div>
        <PageHeader title="Clientes" subtitle="Cargando información..." />

        <Card>
          <SkeletonCard />
          <SkeletonCard />
          <SkeletonCard />
        </Card>
      </div>
    );
  }
  return (
    <div>
      {toast && <Toast message={toast.message} type={toast.type} />}
      <PageHeader
        title="Clientes"
        subtitle="Gestioná clientes, estados y operaciones activas"
        action={
          <Button onClick={() => setOpenModal(true)}>+ Nuevo cliente</Button>
        }
      />
      <SearchBar
        placeholder="Buscar cliente..."
        buttonText="Buscar"
        value={search}
        onChange={(e) => setSearch(e.target.value)}
      />
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))",
          gap: 16,
          marginBottom: 20,
        }}
      >
        <Card>
          <h3 style={{ marginTop: 0 }}>Clientes</h3>
          <p
            style={{
              fontSize: 28,
              fontWeight: 700,
              margin: 0,
            }}
          >
            {clients.length}
          </p>
        </Card>

        <Card
          style={{
            border: "1px solid #fecaca",
            boxShadow: "0 10px 24px rgba(220,38,38,0.08)",
          }}
        >
          <h3 style={{ marginTop: 0 }}>Morosos</h3>
          <p
            style={{
              fontSize: 28,
              fontWeight: 700,
              margin: 0,
              color: "#dc2626",
            }}
          >
            {clients.filter((c) => c.estado === "MOROSO").length}
          </p>
        </Card>

        <Card
          style={{
            border: "1px solid #fed7aa",
            boxShadow: "0 10px 24px rgba(249,115,22,0.08)",
          }}
        >
          <h3 style={{ marginTop: 0 }}>Deuda Total</h3>
          <p
            style={{
              fontSize: 28,
              fontWeight: 700,
              margin: 0,
            }}
          >
            {new Intl.NumberFormat("es-AR", {
              style: "currency",
              currency: "ARS",
            }).format(
              clients.reduce(
                (acc, client) => acc + (client.totalDeuda || 0),
                0,
              ),
            )}
          </p>
        </Card>
      </div>
      <Card>
        <div className="cc-list-header">
          <span>Cliente</span><span>Estado</span><span>Créditos</span><span>Deuda</span><span></span>
        </div>
        {filteredClients.length > 0 ? (
          filteredClients.map((c) => (
            <ClientCard key={c._id} client={c} onDelete={handleDeleteClient} />
          ))
        ) : (
          <div
            style={{
              padding: 30,
              textAlign: "center",
              color: "#6b7280",
            }}
          >
            <h3 style={{ marginBottom: 8 }}>No se encontraron clientes</h3>

            <p style={{ margin: 0 }}>
              Probá con otro nombre o agregá un nuevo cliente
            </p>
          </div>
        )}
      </Card>
      <Modal
        open={openModal}
        onClose={() => setOpenModal(false)}
        title="Nuevo Cliente"
      >
        <FormInput
          label="Nombre"
          placeholder="Juan"
          value={nombre}
          onChange={(e) => setNombre(e.target.value)}
        />

        <FormInput
          label="Apellido"
          placeholder="Perez"
          value={apellido}
          onChange={(e) => setApellido(e.target.value)}
        />

        <FormInput
          label="Fecha Nacimiento"
          type="date"
          value={fechaNacimiento}
          onChange={(e) => setFechaNacimiento(e.target.value)}
        />

        <label
          style={{
            display: "block",
            marginBottom: 6,
            color: "#4b5563",
            fontSize: 14,
          }}
        >
          Sexo
        </label>

        <select
          value={sexo}
          onChange={(e) => setSexo(e.target.value)}
          style={{
            width: "100%",
            padding: "14px 16px",
            marginBottom: 16,
            border: "1px solid #d1d5db",
            borderRadius: 12,
            fontSize: 16,
            backgroundColor: "white",
            boxSizing: "border-box",
          }}
        >
          <option value="">Seleccionar sexo</option>
          <option value="MASCULINO">Masculino</option>
          <option value="FEMENINO">Femenino</option>
          <option value="OTRO">Otro</option>
        </select>

        <FormInput
          label="Nacionalidad"
          value={nacionalidad}
          onChange={(e) => setNacionalidad(e.target.value)}
        />

        <label
          style={{
            display: "block",
            marginBottom: 6,
            color: "#4b5563",
            fontSize: 14,
          }}
        >
          Estado Civil
        </label>

        <select
          value={estadoCivil}
          onChange={(e) => setEstadoCivil(e.target.value)}
          style={{
            width: "100%",
            padding: "14px 16px",
            marginBottom: 16,
            border: "1px solid #d1d5db",
            borderRadius: 12,
            fontSize: 16,
            backgroundColor: "white",
            boxSizing: "border-box",
          }}
        >
          <option value="">Seleccionar estado civil</option>
          <option value="SOLTERO">Soltero/a</option>
          <option value="CASADO">Casado/a</option>
          <option value="DIVORCIADO">Divorciado/a</option>
          <option value="VIUDO">Viudo/a</option>
          <option value="SEPARADO">Separado/a</option>
          <option value="UNION_CONVIVENCIAL">Unión convivencial</option>
          <option value="OTRO">Otro</option>
        </select>

        <FormInput
          label="Teléfono"
          placeholder="11 1234-5678"
          value={telefono}
          onChange={(e) => setTelefono(e.target.value)}
        />

        <FormInput
          label="Dirección"
          placeholder="Calle 123"
          value={direccion}
          onChange={(e) => setDireccion(e.target.value)}
        />

        <FormInput
          label="Provincia"
          value={provincia}
          onChange={(e) => setProvincia(e.target.value)}
        />

        <FormInput
          label="Localidad"
          value={localidad}
          onChange={(e) => setLocalidad(e.target.value)}
        />

        <FormInput
          label="Código Postal"
          value={codigoPostal}
          onChange={(e) => setCodigoPostal(e.target.value)}
        />

        <FormInput
          label="DNI"
          placeholder="30123456"
          value={dni}
          onChange={(e) => setDni(e.target.value)}
        />

        <FormInput
          label="CUIL"
          placeholder="20-30123456-3"
          value={cuil}
          onChange={(e) => setCuil(e.target.value)}
        />

        <FormInput
          label="Email"
          placeholder="cliente@email.com"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />

        <FormInput
          label="Empresa"
          placeholder="Empresa donde trabaja"
          value={empresa}
          onChange={(e) => setEmpresa(e.target.value)}
        />

        <FormInput
          label="Ocupación"
          placeholder="Empleado, comerciante, etc."
          value={ocupacion}
          onChange={(e) => setOcupacion(e.target.value)}
        />

        <FormInput
          label="Ingresos Mensuales"
          placeholder="500000"
          thousandSeparator
          value={ingresosMensuales}
          onChange={(e) => setIngresosMensuales(e.target.value)}
        />

        <FormInput
          label="Antigüedad Laboral"
          value={antiguedadLaboral}
          onChange={(e) => setAntiguedadLaboral(e.target.value)}
        />

        <FormInput
          label="Referencia Nombre"
          value={referenciaNombre}
          onChange={(e) => setReferenciaNombre(e.target.value)}
        />

        <FormInput
          label="Referencia Teléfono"
          value={referenciaTelefono}
          onChange={(e) => setReferenciaTelefono(e.target.value)}
        />

        <FormInput
          label="Referencia Relación"
          value={referenciaRelacion}
          onChange={(e) => setReferenciaRelacion(e.target.value)}
        />

        <FormInput
          label="Alias"
          value={alias}
          onChange={(e) => setAlias(e.target.value)}
        />

        <FormInput
          label="CBU"
          value={cbu}
          onChange={(e) => setCbu(e.target.value)}
        />

        <FormInput
          label="Observaciones"
          placeholder="Información adicional"
          value={observaciones}
          onChange={(e) => setObservaciones(e.target.value)}
        />

        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            gap: 12,
            marginTop: 20,
          }}
        >
          <Button variant="secondary" onClick={() => setOpenModal(false)}>
            Cancelar
          </Button>

          <Button onClick={handleCreateClient}>Crear Cliente</Button>
        </div>
      </Modal>
    </div>
  );
}

export default Clients;
